export const getSourceExtension = (source = ''): string =>
  source ? source.split(/[#?]/)[0].split('.').pop() || ''.trim() : '';
